import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { DocType } from '@tencent/docs-mime-types';
import * as qs from 'querystringify';
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { requestV1Cgi } from "../data-source/network-request";
import { COLLABORATION_SPACE_KIND } from "../model/collaboration-space";
import { DRIVE_FOLDER_KIND, FOLDER_ATTRIBUTE } from "../model/drive-folder";
import { UNKNOWN_USER, UNKNOWN_USER_ID, UNKNOWN_USER_NICK } from "../model/user";
/**
 * 获取腾讯文档 drive 我的文档下的所有文件夹
 */
export function getFolderList(params) {
  return new FolderListRequest(params).send();
}
export var FolderListRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(FolderListRequest, _DriveRequest);
  var _super = _createSuper(FolderListRequest);
  function FolderListRequest() {
    _classCallCheck(this, FolderListRequest);
    return _super.apply(this, arguments);
  }
  _createClass(FolderListRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: '/cgi-bin/online_docs/folder_list',
        data: qs.stringify({
          folder_id: '/',
          list_type: 5,
          is_recursively: !!params.recursive,
          xsrf: getXsrfToken()
        })
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      var _this = this;
      return {
        folders: response.folders.map(function (item) {
          return _this.getFileNode(item);
        })
      };
    }
  }, {
    key: "getFileNode",
    value: function getFileNode(item) {
      // vip 信息
      var ownerVipInfo = JSON.parse(item.owner_vip_info || 'null');
      var fileNode = {
        kind: '',
        id: item.folder_id,
        title: item.title,
        collaborationFlag: item.collaboration_flag,
        createTs: item.create_ts,
        creator: UNKNOWN_USER,
        docType: DocType.Unknown,
        iconUrl: '',
        lastBrowseTs: 0,
        lastDeleteTs: 0,
        lastModifyTs: item.modify_ts,
        lastModifier: {
          uid: item.modify_uid || UNKNOWN_USER_ID,
          nick: UNKNOWN_USER_NICK
        },
        mimeType: item.mime_type,
        owner: {
          uid: item.owner_uid,
          nick: UNKNOWN_USER_NICK,
          avatarFrameUrl: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.avatar_frame_url,
          expiredStatus: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.expired_status,
          vipLevel: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.vip_level,
          renewalStatus: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.renewal_status
        },
        originParentId: item.origin_folder_id || null,
        // 空字符串 fallback 到 null
        parentId: item.parent_folder_id,
        thirdAppId: null,
        // 空字符串 fallback 到 null
        isOwnedByMe: false
      };
      if (item.collaboration_flag === 1) {
        Object.assign(fileNode, {
          kind: COLLABORATION_SPACE_KIND,
          attribute: null,
          roleId: item.role_id
        });
      } else {
        Object.assign(fileNode, {
          kind: DRIVE_FOLDER_KIND,
          // 目前只能搜到自己的数据，因此文件夹都有权限
          attribute: FOLDER_ATTRIBUTE
        });
      }
      return fileNode;
    }
  }]);
  return FolderListRequest;
}(DriveRequest);
//# sourceMappingURL=folder-list.js.map